<template>
  <div class="container-fluid">

    <!-- Mes article -->
    <div class="container-fluid">
      <router-view></router-view>

    </div>
  </div>
</template>

<script>

//import componante

  export default {
    name: 'Home',
  
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
